export default function PipelineLoadingFallback() {
  return (
    <div
      className="h-8 w-full rounded bg-lightest animate-pulse"
      role="status"
      aria-label="Loading"
    />
  );
}
